export default __webpack_public_path__ + "static/lysicrates-james-martin-waverley-cemetery-vault-c126d24f5fb751a2c882e62ce7fe4ef6.png";